import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DataProtectionNoticeListFacade } from './data-protection-notice-list.facade';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class DataProtectionNoticeListGuard {
  constructor(private dpnListFacade: DataProtectionNoticeListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.dpnListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.dpnListFacade);
  }
}
